<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <div class="header-button">
      <search-form
        ref="searchForm"
        :fields="search"
      />
      <div class="selections">
        <button-link
          type="success"
          to="/recharge_configuration/create"
        >
          <slot>添加充值类型</slot>
        </button-link>
      </div>
    </div>

    <el-table
      :data="recharge_configuration"
      resource="recharge_configuration"
    >
      <!-- <el-table-column
        prop="id"
        label="ID"
        width="60"
        align="center"
      />-->
      <el-table-column
        prop="name"
        label="名称"
        width="150"
        align="center"
      />
      <el-table-column
        prop="recharge_money"
        label="充值金额"
        width="150"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag type="success">{{ scope.row.recharge_money }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="give_money"
        label="赠送金额"
        width="150"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag type="danger">{{ scope.row.give_money }}</el-tag>
        </template>
      </el-table-column>

      <!-- <el-table-column
        prop="discount"
        label="折扣"
        width="80"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.discount == 1">无折扣</el-tag>
          <el-tag v-else>{{ scope.row.discount * 10 }} 折</el-tag>
        </template>
      </el-table-column> -->

      <el-table-column
        prop="area_name"
        label="区域"
      >
        <template #default="{ row }">
          <el-tag class="mr-1">
            {{ row.area_name }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column
        label="状态"
        width="100"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.status"
            type="success"
          >启用</el-tag>
          <el-tag
            v-else
            type="danger"
          >禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="start_at"
        label="开始时间"
        width="160"
        align="center"
      />
      <el-table-column
        prop="end_at"
        label="结束时间"
        width="160"
        align="center"
      />

      <!-- <el-table-column
              prop="created_at"
              label="添加时间"
              width="160"
              align="center"
            />
            <el-table-column
              prop="updated_at"
              label="修改时间"
              width="160"
              align="center"
            /> -->
      <el-table-column
        label="操作"
        width="150"
      >
        <template #default="{ row, $index }">
          <el-button-group>
            <row-to-edit />
            <row-destroy />
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <div class="card-footer">
      <pagination :page="page" />
    </div>
  </el-card>
</template>

<script>
import SearchForm from "@c/SearchForm";
import Pagination from "@c/Pagination";
import { getRechargeConfiguration } from "@/api/recharge-configuration";
import RowDestroy from "@c/LzTable/RowDestroy";
import RowToEdit from "@c/LzTable/RowToEdit";
import ButtonLink from "@c/ButtonLink";
import { getAreas } from "@/api/area";
import { mixinsAutoPageSize } from "@/libs/utils";
import { getAdminUsersMerchant } from "@/api/admin-merchant";
import env from "../../../env";
export default {
  name: "Index",
  components: {
    RowToEdit,
    RowDestroy,
    SearchForm,
    Pagination,
    ButtonLink
  },
  data() {
    return {
      search: [
        {
          type: "el-select",
          field: "area_id",
          label: "骑行区域",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        },
        {
          field: "name",
          label: "名称"
        },
        {
          type: "el-select",
          field: "status",
          label: "是否禁用",
          options: [
            {
              id: "",
              name: "全部"
            },
            {
              id: 1,
              name: "启用"
            },
            {
              id: 0,
              name: "禁用"
            }
          ]
        }
        // {
        //   type: 'el-select',
        //   field: 'is_discount',
        //   label: '是否折扣',
        //   options: [
        //     {
        //       id: '',
        //       name: '全部',
        //     },
        //     {
        //       id: 1,
        //       name: '有折扣',
        //     },
        //     {
        //       id: 0,
        //       name: '无折扣',
        //     },
        //   ],
        // },
      ],
      recharge_configuration: [],
      page: null,
      first_blood: true
    };
  },
  async created() {
    const [{ data: areas }] = await Promise.all([getAreas({ all: 1 })]);
   
    if (this.$store.state.users.user.roles[0] === "administrator") {
      const [{ data: merchant }] = await Promise.all([
        getAdminUsersMerchant({ all: 1 })
      ]);
       if (env.isPosSwitch == true) {
      this.search.push({
        type: "el-select",
        field: "merchant_id",
        label: "商户",
        options: [
          {
            id: "",
            name: "全部"
          }
        ]
      });
      this.search[3].options.push.apply(this.search[3].options, merchant.data);
    }
    }

    this.search[0].options.push.apply(this.search[0].options, areas);
  },
  mixins: [mixinsAutoPageSize],
  watch: {
    $route: {
      async handler(newVal) {
        await this.autoPageSize(53, newVal);
        const {
          data: { data, meta }
        } = await getRechargeConfiguration(newVal.query);
        this.recharge_configuration = data;
        this.page = meta;
      },
      immediate: true
    }
  }
};
</script>
<style lang="scss" scoped>
.header-button {
  display: flex;
  justify-content: space-between;

  .selections {
    display: inline-block;
    margin-right: 10px;
  }
}
</style>
